
const state = {
  isAuth: false,
  id: '',
  name: '',
  level: 1,
  hp: '',
  profile_img: '',
  isAdmin: false,
  isManager: false,
  isStaff: false,
  isPlusMember: false,
  isPartner: false,
  token: '',
  modal: {
    login: false,
    join: false
  }
}

const getters = {
}

const mutations = {
  setToken (state, {token}) {
    if (state.token !== token && token !== undefined) {
      state.token = token
      // console.log(`token: ${state.token} / `, token)
    }
  },
  setMember: function (state, data) {
    // console.log('setMember:', data)
    if (data !== undefined) {
      state.isAuth = true
      state.id = data.id
      state.name = data.name
      state.level = data.level
      state.hp = data.hp
      state.profile_img = data.profile_img
      if (data.level > 2) state.isStaff = true
      if (data.level >= 6) state.isManager = true
      if (data.level >= 8) state.isAdmin = true
      state.isPlusMember = (data.plus_member === '1')
      state.isPartner = (data.partner_member === '1')
      // 맵 확대 제한
    }
  },
  logout (state) {
    state.isAuth = false
    state.id = ''
    state.name = ''
    state.level = 1
    state.hp = ''
    state.isStaff = false
    state.isPlusMember = false
    state.isPartner = false
    state.profile_img = ''
    state.token = 'null'
  }
}

const actions = {
  requestAuthData ({ commit, state }, p) {
    return this.requestData(`/rep.auth.api`, {'param': p}, {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js